var React = require('react');

function ChevronBlue (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".b{fill:#fff}")),React.createElement("path",{"fill":"#14467a","d":"M0 0h38v38H0z","key":1}),React.createElement("path",{"className":"b","d":"M6.035 14.37l3.535-3.535 12.728 12.728-3.535 3.536z","key":2}),React.createElement("path",{"className":"b","d":"M15.407 23.565l12.728-12.728 3.536 3.535L18.943 27.1z","key":3})]);
}

ChevronBlue.defaultProps = {"viewBox":"0 0 38 38"};

module.exports = ChevronBlue;

ChevronBlue.default = ChevronBlue;
